<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <h3>{{ title }}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 lista-metas">
        <div
          v-for="meta in metas"
          :key="`meta-${meta.numero}`"
          class="card-metas"
        >
          <a role="button" @click="$emit('click', meta)">
            <img
              :title="meta.titulo"
              :data-toggle="'popover'"
              :data-content="meta.objetivo"
              :data-placement="'top'"
              :data-trigger="'hover'"
              :src="`${imgUrl}${meta.imagem_url}`"
              :alt="
                `imagem representando a meta ${meta.titulo} para filtrar a lista`
              "
              class="imgODS"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    metas: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      imgUrl: this.$root.$data.imgUrl
    }
  },
  methods: {
    triggerPopover() {
      window.jQuery('[data-toggle="popover"]').popover({})
    }
  },
  mounted() {
    this.triggerPopover()
  },
  updated() {
    this.triggerPopover()
  }
}
</script>

<style scoped>
.lista-metas {
  display: flex;
  flex-wrap: wrap;
}

img {
  width: 70px;
  transition: all ease 0.1s;
}

img:hover {
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/CardsODS/CardsFiltro.vue